<div class="h-full flex flex-col">
  <div>
    <prox-breadcrumb></prox-breadcrumb>
  </div>
  <div class="flex grow mt-3 min-h-0">
    <div *ngIf="items.length" class="sidebar-wrapper" [class.collapsed]="isSidebarCollapsed">
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <div class="sidebar-container">
        <!-- Accordion. Sections start collapsed; RouteFns.expandActiveSection opens the one
             holding the current route, so you can see where you are without the menu running
             past the fold. -->
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="false"></p-panelMenu>
      </div>
    </div>
    <div class="grow flex flex-col qb-manager-content min-h-0 overflow-hidden">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>